import {createAsyncThunk} from '@reduxjs/toolkit'

import {isApiError} from '@shared/helpers/api'
import {isEmpty, isNil} from '@shared/helpers/lang'

import {RecommendationProductState, productOrderListSelector} from '@web/slices/recommendationProduct/slice'

import api from './apis'
import {GFPWaterfallResponse} from './interfaces'

type RootState = {
    recommendationProduct: RecommendationProductState
}

export const getGFPWaterfallByAPI = createAsyncThunk<
    GFPWaterfallResponse,
    {
        unitId: string
        elementId: string
        renderUrl: string
    },
    {
        state: RootState
    }
>('recommendationProduct/getGFPWaterfallByAPI', async ({unitId, renderUrl, elementId}, {rejectWithValue, getState}) => {
    const state = getState()
    const productOrderList = productOrderListSelector(state)

    try {
        if (
            isEmpty(unitId) ||
            isNil(productOrderList) ||
            isEmpty(productOrderList) ||
            isEmpty(renderUrl) ||
            isEmpty(unitId)
        ) {
            return rejectWithValue('PROPS_NOT_VALIDATE')
        }

        const response = await api.getGFPWaterfallResponse({
            unitId,
            productOrderList,
            renderUrl,
            elementId,
        })

        if (!response) {
            return rejectWithValue('RESPONSE_NOT_VALIDATE')
        }

        return response
    } catch (e) {
        if (isApiError(e)) {
            return rejectWithValue(e.response?.data?.result)
        }
        throw e
    }
})
